export default __webpack_public_path__ + "static/media/alex_gizis.922dd7cf.png";